import { render, staticRenderFns } from "./supplier-list.vue?vue&type=template&id=6d08f049&scoped=true&"
import script from "./supplier-list.vue?vue&type=script&lang=js&"
export * from "./supplier-list.vue?vue&type=script&lang=js&"
import style0 from "./supplier-list.vue?vue&type=style&index=0&id=6d08f049&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08f049",
  null
  
)

export default component.exports